import { type EffectCallback, useEffect, useRef } from 'react';

/**
 * Custom hook that runs an effect only once on component mount.
 * This is a semantic wrapper around useEffect that ensures the effect runs only once.
 *
 * @param effect - The effect callback to run on mount
 *
 * @example
 * useMountEffect(() => {
 *   console.log('Component mounted');
 *   fetchInitialData();
 * });
 */
export const useMountEffect = (effect: EffectCallback) => {
  const hasRun = useRef(false);
  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      return effect();
    }
  });
};